<template>
  <!-- Used when someone picks "Menu on top" in the user menu (libs/menuLayout.js). -->
  <layout-horizontal>
    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <!-- The logo sits on the white menu row: on the crimson bar the crimson shield disappeared. -->
    <template #menu-brand>
      <b-link to="/" class="top-menu-brand" aria-label="Home">
        <img :src="logo" alt="Harvard University" class="brand-wordmark" />
        <img :src="shield" alt="Harvard University" class="brand-shield" />
      </b-link>
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-horizontal>
</template>

<script>
import { BLink } from 'bootstrap-vue';
import LayoutHorizontal from '@core/layouts/layout-horizontal/LayoutHorizontal.vue';
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from '../components/Navbar.vue';

export default {
  components: {
    // AppCustomizer,
    BLink,
    LayoutHorizontal,
    Navbar,
  },
  data() {
    return {
      // Shield with the "HARVARD UNIVERSITY" wordmark, which suits a wide, short row.
      logo: require('@/assets/images/logo/logo2.png'),
      // Shield on its own, for screens where the wordmark would push the menu items off the row.
      shield: require('@/assets/images/logo/logo.png'),
      // showCustomizer: $themeConfig.layout.customizer,
    };
  },
};
</script>

<style lang="scss">
// Logo first, then the menu items, on the white menu row.
.horizontal-layout .navbar-horizontal .menu-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.horizontal-layout .navbar-horizontal .menu-row > .navbar-container {
  flex: 1 1 auto;
  min-width: 0;
}

.horizontal-layout .top-menu-brand {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding: 0 1rem 0 0.75rem;
  margin-right: 0.25rem;
  border-right: 1px solid #ebe9f1;
}

.horizontal-layout .top-menu-brand img {
  height: 30px;
  width: auto;
}

.horizontal-layout .top-menu-brand .brand-shield {
  display: none;
}

// Keep all ten items on one row as the screen narrows (the top menu shows from 1200px up):
// below 1500px the item icons go, below 1280px the wordmark becomes just the shield.
@media (max-width: 1499.98px) {
  .horizontal-layout .navbar-horizontal #main-menu-navigation > li > .nav-link > svg:first-child {
    display: none;
  }
}

@media (max-width: 1279.98px) {
  .horizontal-layout .top-menu-brand .brand-wordmark {
    display: none;
  }

  .horizontal-layout .top-menu-brand .brand-shield {
    display: block;
    height: 32px;
  }
}

// Ten menu items on one row at typical desktop widths: tighter spacing than the template default.
.horizontal-layout .navbar-horizontal #main-menu-navigation > li > .nav-link {
  padding: 0.65rem 0.75rem;
  font-size: 0.95rem;
  white-space: nowrap;
}

.horizontal-layout .navbar-horizontal #main-menu-navigation > li > .nav-link svg {
  margin-right: 0.4rem;
}

.horizontal-layout .navbar-horizontal #main-menu-navigation {
  flex-wrap: nowrap;
}

@media (max-width: 1399.98px) {
  .horizontal-layout .navbar-horizontal #main-menu-navigation > li > .nav-link {
    padding: 0.65rem 0.55rem;
    font-size: 0.9rem;
  }
}
</style>
